import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const UserOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5 28.999C5 25.8322 8.03368 23.8451 11.2353 23.8451H12.6653V20.9819M27 28.999C27 25.8322 24.8521 23.8451 21.6563 23.8451H18.4489V20.9819M21.9226 8.07422V10.3648C21.9226 10.3648 23.0805 10.8745 23.0805 11.5102V13.8008C23.0805 14.4364 22.6579 14.9461 21.5 14.9461C21.5 18.1129 18.9874 21.8179 15.7858 21.8179C12.5842 21.8179 9.88053 18.1129 9.88053 14.9461C8.72263 14.9461 8.02789 14.4364 8.02789 13.8008V11.5102C8.02789 10.8745 9.18579 10.3648 9.18579 10.3648V8.07422C9.18579 6.17301 9.76474 4.06564 12.6595 4.06564C19.0279 1.20237 23.6595 4.6383 21.9226 8.07422Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { UserOutline };